// ##### 25-04-30 Komarov
import React from 'react';
// ##### Komarov 2025-07-21
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import LargeScreenRatesBlock from './LargeScreenRatesBlock';
import SmallScreenRatesBlock from './SmallScreenRatesBlock';
// ##### 23-11-08 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import CupOfCoffee from '../../../../Library/PageDevices/Animation/CupOfCoffee';

// ##### 23-09-14 Komarov
// import './RatesBlockCSS.css'

// ##### Komarov 2025-07-14
const RatesBlock = () => {
  // ##### 25-02-18 Komarov
  const hotelrates_loaded2 = useSelector(
    state => state.hotelrates.hotelrates_loaded2
  );
  const hotels_avail_loaded = useSelector(
    state => state.hotels.hotels_avail_loaded
  );

  // ##### 23-03-01 Komarov

  return (
    <div data-component="RatesBlock">
      {/* ##### 23-11-08 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        {/*##### 25-02-18 Komarov */}
        {(hotelrates_loaded2 && hotels_avail_loaded && (
          <LargeScreenRatesBlock />
        )) || <CupOfCoffee />}
      </Media>
      <Media lessThan="Laptop-1024-1440">
        {/* ##### 25-02-18 Komarov */}
        {(hotelrates_loaded2 && hotels_avail_loaded && (
          <SmallScreenRatesBlock />
        )) || <CupOfCoffee />}
      </Media>
    </div>
  );
};

export default RatesBlock;
